<template>
  <div class="propertylist">
    <div class="list">
      <div class="item" v-for="item in propertylist" :key="item.id">
        <img :src="item.logo" alt="" />
        <div>{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import residentList1 from "../../../../assets/product/residentList1.png";
import residentList2 from "../../../../assets/product/residentList2.png";
import residentList3 from "../../../../assets/product/residentList3.png";
import residentList4 from "../../../../assets/product/residentList4.png";

export default {
  setup() {
    return reactive({
      propertylist: [
        {
          id: 1,
          logo: residentList1,
          title: "一键开门",
        },
        {
          id: 2,
          logo: residentList2,
          title: "一键缴费",
        },
        {
          id: 3,
          logo: residentList3,
          title: "报事报修",
        },
        {
          id: 4,
          logo: residentList4,
          title: "邻里互动",
        },
      ],
    });
  },
};
</script>

<style scoped>
.propertylist {
  width: 1180px;
  margin: 80px auto 0;
}
.propertylist .list {
    display: flex;
    justify-content: space-between;
}
.propertylist .list .item  {
    text-align: center;
    overflow: hidden;
}
.propertylist .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.propertylist .list .item img {
    width: 280px;
    margin-bottom: 20px;
}
.propertylist .list .item div {
    font-size: 16px;
    color: #333;
}
</style>
